import {createContext, useContext, useState, ReactNode, useCallback} from "react";

interface AlertProps {
	visible: boolean;
	variant: string;
	message: string;
	timeout: number;
}

type AlertContextData = {
  alert: AlertProps | null;
  handleSetAlert: (data: AlertProps) => void;
}

type AlertContextProviderProps = {
  children: ReactNode;
}

const AlertContext = createContext<AlertContextData>({} as AlertContextData);

export function AlertContextProvider(props: AlertContextProviderProps){

	const [alert, setAlert] = useState<AlertProps | null>(null);

	const handleSetAlert = useCallback((data: AlertProps) => {
		setAlert(data);
	}, [])

	const value = {
		alert,
		handleSetAlert,
	}

	return (
		<AlertContext.Provider value={value}>
			{ props.children }
		</AlertContext.Provider>
	)
}

export function useAlert(){
  const value = useContext(AlertContext);
  return value;
}